import React from 'react';

import { TelegramTextEditor } from '../../../../../../shared/ui/TelegramTextEditor/TelegramTextEditor';
import * as S from '../../styles/autobroadcast.styles';
import { AutobroadcastFormComponentProps } from '../../service/autoBroadcast.interface';

export const AutoBroadcastTextEditor = ({
    formik,
    fieldName,
}: AutobroadcastFormComponentProps) => {
    return (
        <S.TextEditor>
            <TelegramTextEditor
                containerHeight={164}
                placeholder={'Сообщение от продавца (опционально)'}
                value={formik?.values?.text || ''}
                onChange={value => {
                    formik.setFieldValue(fieldName, value);
                }}
            />
        </S.TextEditor>
    );
};
